/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { PostfachMailLinkRel, PostfachMailResource } from '@alfa-client/postfach-shared';
import { StateResource } from '@common/tech-shared';
import { UserProfileResource, UserProfileService } from '@alfa-client/user-profile-shared';
import { Component, Input, OnChanges, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'alfa-user-profile-in-postfach-mail-container',
  templateUrl: './user-profile-in-postfach-mail-container.component.html',
  styleUrls: ['./user-profile-in-postfach-mail-container.component.scss'],
  standalone: false,
})
export class UserProfileInPostfachMailContainerComponent implements OnChanges {
  private readonly userProfileService = inject(UserProfileService);

  @Input() postfachMail: PostfachMailResource;

  userProfileStateResource$: Observable<StateResource<UserProfileResource>>;

  ngOnChanges(): void {
    if (this.postfachMail) {
      this.userProfileStateResource$ = this.userProfileService.getAssignedUserProfile(
        this.postfachMail,
        PostfachMailLinkRel.CREATED_BY,
      );
    }
  }
}
